import React, { useState } from 'react'

import { Form, Col, Select } from 'antd'

import { getMessage } from '../../util/IntlMessages'
import CustomLabel from '../CustomLabel/CustomLabel'

const { Option } = Select

const CustomSelect = function ({
  errors = {},
  setFieldValue,
  rowSpan,
  value,
  values = [],
  field,
  onChange,
  multiple,
  enable,
  onChangeWithField,
  showSearch = true,
  onSearch,
  loading,
  notFoundContent,
  suffixLabel,
  name = '',
  customFormId = '',
  placeholder,
  label = '',
  icon,
  title,
  required,
  information,
  sort = true,
  id = ''
}) {
  const renderFieldName = name ? name : field
  let strFieldText = field
  // Caso nao tenha customFormId e campo fixo e deve estar no language a traducao
  if (customFormId === '' && label === '') {
    strFieldText = getMessage(field)
  }

  const [, setSearchResults] = useState([])
  const labelName = label || `${strFieldText}${suffixLabel ? ' '.concat(suffixLabel) : ''}`
  const renderLabel = CustomLabel(labelName, { value, name, field, information, title, icon, required, id })
  const options = sort ? [...values].sort((a, b) => (a.description > b.description && 1) || -1) : [...values]

  let customNotFound = notFoundContent
  if (loading) {
    customNotFound = (
      <center>
        <b>Carregando...</b>
      </center>
    )
  }

  return (
    <Col xs={24} sm={24} md={rowSpan} lg={rowSpan} xl={rowSpan}>
      <Form.Item
        label={renderLabel}
        validateStatus={errors[renderFieldName] ? 'error' : 'validating'}
        help={errors[renderFieldName]}
      >
        <Select
          showSearch={showSearch}
          onSearch={(inputValue) => {
            const filteredOptions = options.filter((item) =>
              item.description.toLowerCase().includes(inputValue.toLowerCase())
            )
            setSearchResults(filteredOptions.slice(0))
            if (onSearch) {
              onSearch(inputValue)
            }
          }}
          disabled={enable || false}
          mode={multiple ? 'multiple' : ''}
          name={renderFieldName}
          id={id}
          placeholder={placeholder ? placeholder : getMessage('select')}
          allowClear
          onChange={(value) => {
            setFieldValue(renderFieldName, value, customFormId)
            if (onChange) {
              onChange(value, customFormId)
            }

            if (onChangeWithField) {
              onChangeWithField(renderFieldName, value, customFormId)
            }
          }}
          optionFilterProp="children"
          value={value[renderFieldName]}
          filterOption={(input, option) =>
            option.props.children.props.children.toLowerCase().includes(input.toLowerCase())
          }
          loading={loading || false}
          notFoundContent={customNotFound}
        >
          {options.map((item) => (
            <Option key={item.value} value={item.value}>
              <p style={{ margin: '0px', marginLeft: '5px' }}>{item.description}</p>
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
  )
}

export default React.memo(CustomSelect)
